// Best-effort country handling for the leaderboard flag. We never ask the user;
// we infer a 2-letter region from their browser locale, which is imperfect
// (locale ≠ residence) but good enough for a cosmetic flag.

/** Infer an ISO-3166 alpha-2 country from the browser locale, or null. */
export function detectCountry(): string | null {
  try {
    const langs = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const lang of langs) {
      if (!lang) continue;
      // maximize() fills in the likely region (e.g. "uk" → "uk-Cyrl-UA").
      const region = new Intl.Locale(lang).maximize().region;
      if (region && /^[A-Z]{2}$/.test(region)) return region;
    }
  } catch {
    /* Intl.Locale unsupported → no flag */
  }
  return null;
}

/** Turn a 2-letter country code into its flag emoji (regional indicators). */
export function flagEmoji(country?: string | null): string {
  if (!country || !/^[A-Za-z]{2}$/.test(country)) return '';
  const base = 0x1f1e6; // 🇦
  const cc = country.toUpperCase();
  return String.fromCodePoint(base + cc.charCodeAt(0) - 65, base + cc.charCodeAt(1) - 65);
}
